//*****************************************************************************
// Axios prende i dati da MongoDB con mongo.php e li immagazzina pure in
// localStorage. Poi usa Hook setRData che riceve...
//*****************************************************************************
const ReadDB = async (setRData) => {
    const axios = require('axios');
  
    try {
      const response = await axios({
        method: 'get',
        url: 'https://web.dida.unifi.it/parole_ricerca/mongo.php',
      });
      //let dati = '['+response.data+']';
      //setRData(response.data);
  
      localStorage.setItem("tags", JSON.stringify(response.data));
  
      setRData(response.data);
      console.log('assegnato');
      //console.log(response.data);
  
  
    } catch (error) {
      console.log('ERRORE');
    }
  };
  
  export default ReadDB;